
define('inlineSvg!svgs/icon/dropdown-mask', function () {return '<span class="inline-dropdown-mask inline-icon"><svg width="32" height="32"><path d="M0 0v32h32V0H0zm16.2 22.9L3.8 13.1l.6-.7L16.2 19 28 12.4l.6.7-12.4 9.8z"/></svg></span>';});

